var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'program-live-status--label',
    ("live-status--" + _vm.liveStatus) ]},[(_vm.liveStatus === 'live')?_c('span',[_vm._v(_vm._s(_vm.$t('words.program_live_status_live')))]):(_vm.liveStatus === 'end')?_c('span',[_vm._v(_vm._s(_vm.$t('words.program_live_status_end')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }